import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/close.svg'


const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = {
  key: 0,
  class: "input"
}
const _hoisted_3 = { class: "inputbox" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "color" }
const _hoisted_7 = { class: "color" }
const _hoisted_8 = {
  key: 0,
  class: "loading"
}

import { onMounted, onActivated, reactive } from "vue"
import { getAppChoose } from "@/utils/api"
import { toast } from "@/components/toast"
import NumberPrefix from '@/components/numberprefix.vue'

interface NumberState {
    items: MobileItem[];
    loading: boolean;
    prefixs: string;
    text: string;
    prefix: string;
    prefixtext: string;
    suffix: boolean;
    showprefix: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'number',
  props: {
    id: {
        type: Number,
        default: 1,
    }
},
  emits: ['result'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const state = reactive<NumberState>({
    loading: false,
    items: [],
    prefixs: '',
    text: '',
    prefix: '',
    prefixtext: '全部',
    suffix: false,
    showprefix: false,
})
const fetchMobile = async () => {
    console.log('fetchMobile')
    state.loading = true
    const rsp = await getAppChoose(props.id, state.prefix, state.text)
    state.loading = false;
    if (rsp.result == 0) {
        if (!state.prefix && rsp.data.prefixs.length > 0) {
            state.prefixtext = rsp.data.prefixs[0].text
            state.prefix = rsp.data.prefixs[0].value
        }
        state.items = rsp.data.items
        state.prefixs = JSON.stringify(rsp.data.prefixs);
    } else {
        toast(rsp.message)
    }
}
const onCancel = () => {
    console.log('onCancel')
    emit('result', undefined)
}
const clickItem = (mobile: MobileItem) => {
    console.log('click item')
    emit('result', mobile)
}
const onClickPane = () => {
    console.log('onClickPane')
}
const fmtMobile = (text: string, index: 1 | 2 | 3): string => {
    if (index == 3) {
        return text.substring(7, 12)
    }
    if (index == 2) {
        return text.substring(3, 7)
    }
    return text.substring(0, 3)
}
const onTextInput = () => {

}
const onPrefixResult = (text: string, value: string) => {
    if(text) {
        state.prefixtext = text
        state.prefix = value
    }
    state.showprefix = false;
}
onMounted(() => {
    fetchMobile()
})
onActivated(() => {
    fetchMobile()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "pane",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", { class: "title" }, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text" }, "选择号码", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "X",
          class: "close",
          onClick: onCancel
        })
      ]),
      (!state.loading || state.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                onFocus: onTextInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.text) = $event)),
                type: "number",
                class: "text",
                placeholder: "您喜欢的数字,最多4位",
                maxlength: "4"
              }, null, 544), [
                [_vModelText, state.text]
              ])
            ]),
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchMobile()))
            }, "搜索")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: ($event: any) => (clickItem(item))
          }, [
            _createElementVNode("span", null, _toDisplayString(fmtMobile(item.mobile, 1)), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(fmtMobile(item.mobile, 2)), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(fmtMobile(item.mobile, 3)), 1)
          ], 8, _hoisted_5))
        }), 128)),
        (state.loading || state.items.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[6] || (_cache[6] = [
              _createStaticVNode("<div class=\"chase\" data-v-1b5be2a2><div class=\"dot\" data-v-1b5be2a2></div><div class=\"dot\" data-v-1b5be2a2></div><div class=\"dot\" data-v-1b5be2a2></div><div class=\"dot\" data-v-1b5be2a2></div><div class=\"dot\" data-v-1b5be2a2></div><div class=\"dot\" data-v-1b5be2a2></div></div>", 1)
            ])))
          : _createCommentVNode("", true)
      ]),
      (state.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "change",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchMobile()))
          }, "换一批"))
        : _createCommentVNode("", true)
    ]),
    (state.showprefix)
      ? (_openBlock(), _createBlock(NumberPrefix, {
          key: 0,
          text: state.prefixs,
          value: state.prefix,
          onResult: onPrefixResult
        }, null, 8, ["text", "value"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (onCancel()))
    })
  ]))
}
}

})